import * as Yup from 'yup'

export const schemaSearchExistingClient = Yup.object().shape({
  ssn: Yup.string()
    .matches(/^\d+$/, 'SSN must contain digits only')
    .required('SSN is required'),
  companyName: Yup.string().trim(),
})


